"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTheme = exports.breakpointsMatui = void 0;
const createBreakpoints_1 = __importDefault(require("./createBreakpoints"));
/**
 * Material UI breakpoints
value         |0px     600px    960px    1280px   1920px  2560px
key           |xs      sm       md       lg       xl      qhd
screen width  |--------|--------|--------|--------|--------|------------->
range         |   xs   |   sm   |   md   |   lg   |   xl   |     qhd
*/
exports.breakpointsMatui = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
    qhd: 2560,
};
exports.defaultTheme = {
    navHeight: 52,
    breakpoints: (0, createBreakpoints_1.default)({ values: exports.breakpointsMatui }),
    easing: "ease-out",
    logo: {
        src: "https://cdn2.unrealengine.com/ue-logo-lockup2-443x58-cf2b958c7034.png",
        margin: "0 24px 0 12px",
        width: 218,
        node: null,
    },
    forwardIcon: "arrow-forward",
    palette: {
        text: {
            primary: "#fff",
            secondary: "#DBDEE3",
            eyebrow: "#ccc",
            primaryHover: "#009DDF",
        },
        background: {
            default: "#202337",
            paper: "#0E1128",
        },
        border: "#383B50",
        accent: {
            text: "#009DDF",
            background: "radial-gradient(100% 185.14% at 100% 100%, #34C3FF 0%, #338EEE 100%)",
            backgroundHover: "#338EEE",
            backgroundText: "#000",
            backgroundTextHover: "#000",
        },
    },
    fonts: {
        default: "OpenSans, sans-serif, arial",
        heading2: "OpenSans, sans-serif, arial",
        heading3: "OpenSans, sans-serif, arial",
        heading4: "OpenSans, sans-serif, arial",
        paragraph: "OpenSans, sans-serif, arial",
    },
};
//# sourceMappingURL=defaultTheme.js.map